import { render, staticRenderFns } from "./buttonform.vue?vue&type=template&id=52f722de&"
import script from "./buttonform.vue?vue&type=script&lang=js&"
export * from "./buttonform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports